var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgBarChartHorizontal = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#894BA2"
    },
    d: "M391.596,91.045H9.002c-4.662,0-8.44,3.779-8.44,8.44v74.678c0,4.661,3.778,8.44,8.44,8.44h382.593 c4.662,0,8.44-3.779,8.44-8.44V99.484C400.035,94.824,396.258,91.045,391.596,91.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#763794"
    },
    d: "M391.596,91.045h-33.758v91.557h33.758c4.662,0,8.44-3.779,8.44-8.44V99.484 C400.035,94.824,396.258,91.045,391.596,91.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77935"
    },
    d: "M307.682,227.101H9.002c-4.662,0-8.44,3.779-8.44,8.44v74.677c0,4.661,3.778,8.44,8.44,8.44h298.679 c4.662,0,8.44-3.779,8.44-8.44V235.54C316.121,230.879,312.343,227.101,307.682,227.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9510D"
    },
    d: "M307.682,227.101h-33.758v91.556h33.758c4.662,0,8.44-3.779,8.44-8.44V235.54 C316.121,230.879,312.343,227.101,307.682,227.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB56"
    },
    d: "M214.37,363.158H9.002c-4.662,0-8.44,3.779-8.44,8.44v74.677c0,4.661,3.778,8.44,8.44,8.44H214.37 c4.662,0,8.44-3.779,8.44-8.44v-74.677C222.81,366.935,219.032,363.158,214.37,363.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBA806"
    },
    d: "M214.37,363.158h-33.758v91.556h33.758c4.662,0,8.44-3.779,8.44-8.44v-74.677 C222.81,366.935,219.032,363.158,214.37,363.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M502.998,512H9.002c-4.662,0-8.44-3.779-8.44-8.44V8.44C0.563,3.779,4.34,0,9.002,0 s8.44,3.779,8.44,8.44v486.681h485.556c4.662,0,8.44,3.779,8.44,8.44S507.66,512,502.998,512z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarChartHorizontal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bar-chart-horizontal.7a811c65.svg";
export { ForwardRef as ReactComponent };